import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
// import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Modal } from '@material-ui/core';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import {
  GET_LIST_GOCHI_KID_USE_SUCCESS,
  getListGochiKidUse
} from '../../actions/Gochis';
import UnusedGochiKidTable from '../organisms/UnusedGochiKidTable';
import UnusedGochiKidModal from '../organisms/UnusedGochiKidModal';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '290px'
  },
  textRed: {
    color: 'red',
    fontSize: 18,
    marginTop: 10
  },
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getListGochiKidUse
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('userId', 'setUserId', ''),
  withState('userName', 'setUserName', ''),
  withState('shopName', 'setShopName', ''),
  withState('menuName', 'setMenuName', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('useDateFrom', 'setUseDateFrom', null),
  withState('useDateTo', 'setUseDateTo', null),
  withState('openUnusedModal', 'updateOpenUnusedModal', false),
  withState('targetRowId', 'setTargetRowId', null),
  withState('isReCallSearch', 'setIsReCallSearch', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => async (event, page, limit) => {
      props.setIsReCallSearch(false);
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        userId: props.userId,
        displayName: props.userName,
        shopName: props.shopName,
        menuName: props.menuName,
        useDateFrom: props.useDateFrom,
        useDateTo: props.useDateTo,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getListGochiKidUse(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          } else if (data.type === GET_LIST_GOCHI_KID_USE_SUCCESS) {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
          } else {
            props.setResultMessage('エラーが発生しました！');
            props.updateLoading(false);
          }
        })
        .catch(() => {
          props.setResultMessage('エラーが発生しました！');
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.handleChangePage(
        null,
        this.props.page,
        this.props.rowsPerPage
      );
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    account,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    userId,
    setUserId,
    userName,
    setUserName,
    menuName,
    setMenuName,
    shopName,
    setShopName,
    useDateFrom,
    setUseDateFrom,
    useDateTo,
    setUseDateTo,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    page,
    setRowsPerPage,
    openUnusedModal,
    updateOpenUnusedModal,
    targetRowId,
    setTargetRowId,
    isReCallSearch,
    setIsReCallSearch
  }) => {
    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      resultMessage,
      setResultMessage,
      isReCallSearch,
      setIsReCallSearch
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
    };

    const progressOkAction = () => {
      if (isReCallSearch) {
        handleChangePage(null, 1, limitNum);
        updateOpenProgress(false);
      } else {
        updateOpenProgress(false);
      }
    };

    const openUnusedGochiKidModal = id => {
      setTargetRowId(id);
      updateOpenUnusedModal(true);
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            こどもごちめし利用履歴編集
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              <TextField
                label="ユーザーID"
                placeholder="ユーザーID"
                type="search"
                className={classes.textField}
                margin="normal"
                value={userId}
                onChange={e => {
                  setUserId(e.target.value);
                }}
              />
              <TextField
                label="ユーザー名"
                placeholder="ユーザー名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={userName}
                onChange={e => {
                  setUserName(e.target.value);
                }}
              />
              <TextField
                label="店舗名"
                placeholder="店舗名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={shopName}
                onChange={e => {
                  setShopName(e.target.value);
                }}
              />
              <TextField
                InputLabelProps={{ shrink: true }}
                label="メニュー名"
                placeholder="メニュー名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={menuName}
                onChange={e => {
                  setMenuName(e.target.value);
                }}
              />
              <TextField
                label="利用日(From)"
                type="date"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={useDateFrom}
                onChange={e => {
                  setUseDateFrom(e.target.value);
                }}
                onBlur={e => {
                  if (!useDateFrom) {
                    e.target.value = '';
                    setUseDateFrom(null);
                  }
                }}
              />
              <TextField
                label="利用日(To)"
                type="date"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={useDateTo}
                onChange={e => {
                  setUseDateTo(e.target.value);
                }}
                onBlur={e => {
                  if (!useDateTo) {
                    e.target.value = '';
                    setUseDateTo(null);
                  }
                }}
              />
            </div>
            <div>
              <SearchButton onClickAction={searchAction} />
            </div>
            <div className={classes.textRed}>
              こどもごちめしの利用履歴を削除（未使用扱いに）する機能は、弊社（Gigi株式会社）が「こどもごちめし」の利用テストを行うために設けたものです。
              <br />
              そのため、弊社が管理するテスト用アカウントでのみご利用ください。
              <br />
              ※なお、検証環境においてはこの限りではありません。
              <br />
              <br />
              レシート登録が必要な場合は、「レシート再登録（1回限り）」を利用した後に利用履歴を未使用に変更しても、レシート再登録の権利は復活しません。
            </div>
          </div>
          {openTable && (
            <UnusedGochiKidTable
              handleChangePage={handleChangePage}
              selectedPage={page}
              setRowsPerPage={setRowsPerPage}
              openUnusedGochiKidModal={openUnusedGochiKidModal}
            />
          )}
        </Paper>

        <Modal className={classes.modal} open={openUnusedModal}>
          <UnusedGochiKidModal
            targetRowId={targetRowId}
            updateOpenUnusedModal={updateOpenUnusedModal}
            progress={progress}
          />
        </Modal>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
